module.exports = "<div class=\"display-wrapper\">\n\t<div class=\"home-heading\">\n\t\tDisplay\n\t</div>\n\n\t<div class=\"display-body\" #displayElement></div>\n\n\t<div class=\"next-btn-wrap\">\n\t\t<a class=\"btn full-width\" (click)=\"onCancel()\">Close</a>\n    </div> \n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/display-modal/display-modal.component.html
// module id = ../../../../../src/app/modals/display-modal/display-modal.component.html
// module chunks = main